import { PredefinedRange } from 'helpers/dateRange'
import { VisitsFilter } from 'models'

/** Fallback used when the subscription's `storedDataTtl` isn't available yet. */
export const DEFAULT_MAX_VISIT_HISTORY_DAYS = 30

/** Visit history is only retained/queryable for `storedDataTtl` days back (subscription-specific). */
export function getMaxVisitHistoryDays(storedDataTtl?: number | null): number {
  return Math.max(1, (storedDataTtl ?? DEFAULT_MAX_VISIT_HISTORY_DAYS) - 1)
}

export enum IdentificationUrlKeys {
  RequestId = 'requestId',
  VisitorId = 'visitorId',
  IpAddress = 'ipAddress',
  Url = 'url',
  LinkedId = 'linkedId',
  Origin = 'origin',
  Asn = 'asn',
  Since = 'since',
  Before = 'before',
  Period = 'period',
  Environment = 'environment',
  SdkPlatform = 'sdkPlatform',
  SdkVersion = 'sdkVersion',
  Limit = 'limit',
  MinSuspectScore = 'minSuspectScore',
  Bot = 'bot',
  BotName = 'botName',
  BotCategory = 'category',
  BotProvider = 'provider',
  BotIdentity = 'identity',
  BotConfidence = 'confidence',
  Vpn = 'vpn',
  IpBlocklist = 'ipBlocklist',
  ResidentialProxy = 'proxy',
  Incognito = 'incognito',
  BrowserTampering = 'tampering',
  VirtualMachine = 'virtualMachine',
  PrivacySettings = 'privacySettings',
  DeveloperTools = 'developerTools',
  Emulator = 'emulator',
  Simulator = 'simulator',
  ClonedApp = 'clonedApp',
  LocationSpoofing = 'locationSpoofing',
  MitmAttack = 'mitmAttack',
  DeviceRarity = 'deviceRarity',
  ActiveCall = 'activeCall',
  RootedDevice = 'rootApps',
  JailbrokenDevice = 'jailbroken',
  Frida = 'frida',
  Tor = 'torNode',
  ProximityId = 'proximityId',
  HighRecallId = 'highRecallId',
}

export type SmartSignalUrlKey = Extract<
  IdentificationUrlKeys,
  | IdentificationUrlKeys.MinSuspectScore
  | IdentificationUrlKeys.Vpn
  | IdentificationUrlKeys.IpBlocklist
  | IdentificationUrlKeys.ResidentialProxy
  | IdentificationUrlKeys.Incognito
  | IdentificationUrlKeys.BrowserTampering
  | IdentificationUrlKeys.VirtualMachine
  | IdentificationUrlKeys.PrivacySettings
  | IdentificationUrlKeys.DeveloperTools
  | IdentificationUrlKeys.Emulator
  | IdentificationUrlKeys.Simulator
  | IdentificationUrlKeys.ClonedApp
  | IdentificationUrlKeys.LocationSpoofing
  | IdentificationUrlKeys.MitmAttack
  | IdentificationUrlKeys.DeviceRarity
  | IdentificationUrlKeys.ActiveCall
  | IdentificationUrlKeys.RootedDevice
  | IdentificationUrlKeys.JailbrokenDevice
  | IdentificationUrlKeys.Frida
  | IdentificationUrlKeys.Tor
>

export type BotDetectionUrlKey = Extract<
  IdentificationUrlKeys,
  | IdentificationUrlKeys.Bot
  | IdentificationUrlKeys.BotName
  | IdentificationUrlKeys.BotCategory
  | IdentificationUrlKeys.BotProvider
  | IdentificationUrlKeys.BotIdentity
  | IdentificationUrlKeys.BotConfidence
>

export type VisitsFilterView = VisitsFilter & {
  since?: string
  before?: string
  period?: PredefinedRange['id']
}

export enum Platform {
  Web = 'web',
  Mobile = 'mobile',
  Universal = 'universal',
}

export enum ServerApiVersion {
  V3 = 'v3',
  V4 = 'v4',
}
